import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import ScrollToTop from './components/ScrollToTop';

// Admin
import AdminApp from './components/admin/AdminApp';

// Public Pages
import Layout from './components/Layout';
import Home from './pages/Home';
import AllHomes from './pages/AllHomes';
import Search from './pages/Search'; // <--- NEW IMPORT
import About from './pages/About';
import Team from './pages/Team';
import Contact from './pages/Contact';
import PropertyDetail from './pages/PropertyDetail';
import DestinationPage from './pages/DestinationPage';

const App = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/*" element={<AdminApp />} />

          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/homes" element={<AllHomes />} />
            <Route path="/search" element={<Search />} /> {/* <--- NEW ROUTE */}

            <Route path="/homes/:slug" element={<PropertyDetail />} />

            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/destinations" element={<DestinationPage type="all" />} />
            <Route path="/destinations/mountain-village-telluride" element={<DestinationPage type="telluride" />} />
            <Route path="/destinations/avon-beaver-creek" element={<DestinationPage type="beavercreek" />} />
            <Route path="/destinations/del-mar-san-diego" element={<DestinationPage type="delmar" />} />
            <Route path="/destinations/south-beach-miami" element={<DestinationPage type="miami" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;